import { MatIconRegistry } from '@angular/material/icon';
import { Provider, APP_BOOTSTRAP_LISTENER, ComponentRef } from '@angular/core';

export function faInitializer() {
  return async (componentRef: ComponentRef<any>) => {
    const matIconRegistry = componentRef.injector.get(MatIconRegistry);
    matIconRegistry.registerFontClassAlias('fas');  // tried with 'fas' and with 'fa'
    matIconRegistry.registerFontClassAlias('fa');  // tried with 'fas' and with 'fa'
  };
}

export const FA_INITIALIZER_PROVIDER: Provider = {
  provide: APP_BOOTSTRAP_LISTENER,
  useFactory: faInitializer,
  multi: true
};
